/**
 * El video de la ficha, dentro de la caja de la foto.
 *
 * Mudo, en loop y con controles: los controles son la pausa que pide WCAG
 * 2.2.2 para algo que se mueve más de cinco segundos. Con
 * `prefers-reduced-motion` no arranca solo: queda detenido hasta que el
 * comprador le dé play.
 *
 * Solo se monta cuando se elige su miniatura, así que la ficha no descarga el
 * video a menos que alguien lo pida.
 *
 * Lleva "Video referencial" a la vista porque la escena no es una toma real
 * del producto: es lo mismo que dicen las fotos referenciales en su texto
 * alternativo, dicho donde se ve.
 */
import type { VideoProducto } from '@bandu/compartido';

import { useConsultaMedios } from '../../hooks/use-consulta-medios';

export interface VideoFichaProps {
  video: VideoProducto;
  nombre: string;
}

export function VideoFicha({ video, nombre }: VideoFichaProps) {
  const menosMovimiento = useConsultaMedios('(prefers-reduced-motion: reduce)');

  return (
    <>
      <video
        className="ficha-video"
        src={video.url}
        width={video.ancho}
        height={video.alto}
        aria-label={`Video referencial de ${nombre}`}
        autoPlay={!menosMovimiento}
        muted
        loop
        playsInline
        controls
        preload="auto"
      />
      <span className="ficha-referencial">Video referencial</span>
    </>
  );
}
